import React, { useState } from "react";
import { useDispatch } from "react-redux";
import _ from 'lodash'
import { Dialog } from "primereact/dialog";

//Helpers
import { Button, DropDownField, TextAreaField, TextInputField } from "../../../helpers"
import { RadioButton } from "primereact/radiobutton";

//Initial values
import { processRejectedStockInitialValues, processRejectedStockValidationSchema } from "../../../validation/stockAdjustment";

//APIs
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { getMaterialMasterAndTempMaterialIds } from '../../../services/api/materialMaster'
import { getCreditNoteStockDataByWarehouseId, processCreditNoteRejectedStock } from "../../../services/api/stockAdjustment";

//Utils
import { sortArrayOfObjectsInAlphabeticalOrder, validateInputs } from "../../../utils";

//components
import Loading from "../../../common/Loading";
import MaterialSearch from "../../../common/MaterialSearch";

const processingTypes = [
    {id: 1, name: 'Move to Discard'},
    {id: 2, name: 'Move to Smart'},
    {id: 3, name: 'Modify Material ID'}
]

const ProcessRejectedStock = (props) => {

    const { companyWarehouses, setVisibleProcessRejectedStock } = props

    const [processRejectedStock, setProcessRejectedStock] = useState(processRejectedStockInitialValues)
    const [creditNoteStockMoves, setCreditNoteStockMoves] = useState([])
    const [creditNotes, setCreditNotes] = useState([])
    const [rejectedProducts, setRejectedProducts] = useState([])
    const [materialDetails, setMaterialDetails] = useState([])

    const [newMaterialDetails, setNewMaterialDetails] = useState([])
    // const [selectedMaterialItemIds, setSelectedMaterialItemIds] = useState([])
    const [selectedProduct, setSelectedProduct] = useState({})

    const [isLoading, setIsLoading] = useState(false)
    const [creditNoteStockMovesDataLoading, setCreditNoteStockMovesDataLoading] = useState(false)
    const [isAddNewMaterial, setIsAddNewMaterial] = useState(false)

    const [formErrors, setFormErrors] = useState({})

    const dispatch = useDispatch()

    const handleProcessRejectedStockChange = (e) => {
        console.log("e.target.value", e.target.name, e.target.value)

        if(e.target.name === "crediNoteDocNo"){
            let relatedCreditNoteMaterials = creditNoteStockMoves.filter(eachStockMove => eachStockMove.docNo === e.target.value)
            console.log("relatedCreditNoteMaterials", relatedCreditNoteMaterials)

            relatedCreditNoteMaterials = relatedCreditNoteMaterials.map(eachMaterial => {
                return {
                    materialId: eachMaterial.materialId,
                    warehouseId: eachMaterial.warehouseId,
                    qty: eachMaterial.moveQty,
                    price: eachMaterial.price,
                    docNo: eachMaterial.docNo,
                    fileNo: eachMaterial.fileNo,
                    buyerPOId: eachMaterial.buyerPOId,
                    sellerPOId: eachMaterial.sellerPOId,
                    sellerPIPunchId: eachMaterial.sellerPIPunchId,
                    sellerPIPunchItemId: eachMaterial.sellerPIPunchItemId,
                    stockMoveId: eachMaterial.stockMoveId,

                    processingTypeId: null,
                    newMaterialId: null
                }
            })

            setRejectedProducts(relatedCreditNoteMaterials)
        }

        if(e.target.name === "processedQty"){

            if(!processRejectedStock['availableQty']){
                return dispatch(raiseToast({severity:'warn', detail: `Please enter available quantity!`, life: 3000}))
            }

            if(e.target.value > parseFloat(processRejectedStock['availableQty'])){ 
                return dispatch(raiseToast({severity:'warn', detail: `Available quantity is ${processRejectedStock.availableQty}`, life: 3000}))
            }
        }

        processRejectedStock[e.target.name] = e.target.value 
        setProcessRejectedStock({...processRejectedStock})
    }

    const handleWarehouseChange = async (e) => {
        setCreditNoteStockMovesDataLoading(true)

        //Fetch stock warehouse data here
        const stockWarehouseRes = await getCreditNoteStockDataByWarehouseId(e.target.value)

        if(stockWarehouseRes.failure){
            setCreditNoteStockMovesDataLoading(false)
            return dispatch(raiseToast({severity:'error', summary: 'stockWarehouseRes', detail: stockWarehouseRes.data.error, life: 3000}))
        }

        console.log("stockWarehouseRes", stockWarehouseRes)
        setCreditNoteStockMoves(stockWarehouseRes.data)

        let uniqueCreditNoteStockMoves = _.uniqBy(stockWarehouseRes.data, "docNo")
        uniqueCreditNoteStockMoves = sortArrayOfObjectsInAlphabeticalOrder(uniqueCreditNoteStockMoves, 'docNo')
        console.log("uniqueCreditNoteStockMoves", uniqueCreditNoteStockMoves)
        setCreditNotes(uniqueCreditNoteStockMoves)

        if (stockWarehouseRes.data.length > 0) {
            const materialIds = _.uniqBy(stockWarehouseRes.data.map(eachStockWar => eachStockWar.materialId))
            const materialRes = await getMaterialMasterAndTempMaterialIds({ materialIds })

            if (materialRes.failure) {
                setCreditNoteStockMovesDataLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: 'materialRes', detail: materialRes.data.error, life: 3000 }))
            }

            console.log("materialRes", materialRes.data)
            const sortedMaterialDetails = _.sortBy(materialRes.data, 'materialId')
            setMaterialDetails(sortedMaterialDetails)
            setRejectedProducts([])
        }
        else if(stockWarehouseRes.data.length === 0){
            setRejectedProducts([])
            setMaterialDetails([])
            dispatch(raiseToast({ severity: 'error', detail: "No rejected material stock was found!", life: 3000 }))
        }

        const updatedProcessRejectedStock = { ...processRejectedStockInitialValues, warehouseId: e.target.value }

        setProcessRejectedStock({ ...updatedProcessRejectedStock})
        setCreditNoteStockMovesDataLoading(false)
    }

    const handleProcessingTypesChange = async (e, materialId) => {
        console.log("e.target.value", e.target.value)
        const updatedRejectedProducts = rejectedProducts.map(eachProduct => {
            console.log("cond", eachProduct.materialId, materialId, eachProduct.materialId === materialId)
            if(eachProduct.materialId === materialId){
                return {...eachProduct, processingTypeId: e.target.value}
            }
            return eachProduct
        })
        console.log("updatedRejectedProducts", updatedRejectedProducts)

        setRejectedProducts(updatedRejectedProducts)
    }

    const handleAddMaterialItemClick = async (selectedMaterialItem) => {
        const updatedRejectedProducts = rejectedProducts.map(eachRejProduct => {
            if(eachRejProduct.materialId === selectedProduct.materialId){
                return {...eachRejProduct, newMaterialId: selectedMaterialItem.materialId}
            }
            return eachRejProduct
        })

        const isMaterialPresent = newMaterialDetails.find(eachMaterial => eachMaterial.materialId === selectedMaterialItem.materialId)

        let updatedNewMaterialDetails = newMaterialDetails
        if(!isMaterialPresent){
            updatedNewMaterialDetails = [...newMaterialDetails, selectedMaterialItem]
        }

        console.log("updatedNewMaterialDetails", updatedNewMaterialDetails)
        setNewMaterialDetails(updatedNewMaterialDetails)

        setRejectedProducts(updatedRejectedProducts)
        setSelectedProduct({})
        setIsAddNewMaterial(false)
    }

    const handleNewMaterialClick = (product) => {
        setIsAddNewMaterial(true)
        setSelectedProduct(product)
    }
    
    const handleProcessRejectedStockSubmit = async () => {

        const validationRes = await validateInputs(processRejectedStockValidationSchema, processRejectedStock)
        console.log("validationRes", validationRes)
        if (validationRes) {
            if (validationRes.error) {
                setFormErrors(validationRes.error)
            }
            else {
                setFormErrors({})

                //Product Validations
                const isProcessingTypeNotSelected = rejectedProducts.some(eachProduct => {
                    if(!eachProduct.processingTypeId){
                        dispatch(raiseToast({ severity: 'warn', detail: `Please enter processing type for material ID ${eachProduct.materialId}`, life: 3000 }))
                        return true
                    }

                    if(eachProduct.processingTypeId === 3 && !eachProduct.newMaterialId){
                        dispatch(raiseToast({ severity: 'warn', detail: `Please enter new material ID for material ${eachProduct.materialId}`, life: 3000 }))
                        return true
                    }

                    return false
                })

                if(isProcessingTypeNotSelected) return

                if(window.confirm("Are you sure you want to continue?")){
                    setIsLoading(true)

                    const processRejectedStockRes = await processCreditNoteRejectedStock({processRejectedStock, rejectedProducts})

                    if(processRejectedStockRes.failure){
                        setIsLoading(false)
                        return dispatch(raiseToast({ severity: 'error', summary: 'Process credit note', detail: processRejectedStockRes.data.error, life: 3000 }))
                    }

                    setIsLoading(false)
                    setVisibleProcessRejectedStock(false)
                    setProcessRejectedStock(processRejectedStockInitialValues)
                }
            }
        }
    }

    // console.log("processRejectedStock", processRejectedStock)
    // console.log("creditNoteStockMoves", creditNoteStockMoves)
    // console.log("materialDetails", materialDetails)
    // console.log("newMaterialDetails", newMaterialDetails)
    console.log("rejectedProducts", rejectedProducts)

    const relatedMaterial = materialDetails.find(eachMaterial => eachMaterial.materialId === processRejectedStock.materialId)
    
    return(
        <>
            <Loading visible={isLoading} />
            <div className="flex flex-wrap">
                <div className="flex flex-row col-12 p-0">
                    <div className="flex flex-column col-12 lg:col-3 lg:mb-0">
                        <DropDownField name="warehouseId" options={companyWarehouses} optionValue="warehouseId" optionLabel="warehouseName" labelText="Warehouse" value={processRejectedStock.warehouseId} onChange={handleWarehouseChange} disabled={creditNoteStockMovesDataLoading} required errorMessage={formErrors.warehouseId} />
                    </div>
                    <div className="flex flex-column col-12 lg:col-3 lg:mb-0">
                        <DropDownField name="crediNoteDocNo" labelText="Credit Note" options={creditNotes} value={processRejectedStock.crediNoteDocNo} optionLabel="docNo" optionValue="docNo" onChange={handleProcessRejectedStockChange} disabled={creditNoteStockMovesDataLoading} errorMessage={formErrors.crediNoteDocNo} loading={creditNoteStockMovesDataLoading} required />
                    </div>
                </div>
                {
                    rejectedProducts.map(eachProduct => {
                        const relatedMaterial = materialDetails.find(eachMaterial => eachMaterial.materialId === eachProduct.materialId)
                        const materialValue = `${relatedMaterial.materialId}-${relatedMaterial.productName}-${relatedMaterial.productSpecification}`
                        const relatedNewMaterial = newMaterialDetails.find(eachMaterial => eachMaterial.materialId === eachProduct.newMaterialId)
                        const newMaterialTooltipText = eachProduct.newMaterialId ? `${relatedNewMaterial.materialId}-${relatedNewMaterial.productName}-${relatedNewMaterial.productSpecification}}` : null

                        return(
                            <div className="flex flex-row col-12 p-0" key={eachProduct.materialId}>
                                <div className="flex flex-column col-12 lg:col-5 lg:mb-0">
                                    <TextInputField name="Material" value={materialValue} labelText="Material" disabled tooltip={materialValue} tooltipOptions={{position: 'top', showOnDisabled: true, showDelay: 500, hideDelay: 150}} />
                                </div>
                                {processingTypes.map(eachProcessingType => {
                                    return (
                                        <div key={`processingType-${eachProcessingType.id}`} className="flex align-items-center">
                                            <RadioButton 
                                                className="mr-1"
                                                name="processingType" 
                                                inputId={`${eachProduct.materialId} ${eachProcessingType.id}`} 
                                                value={eachProcessingType.id} 
                                                onChange={(e) => handleProcessingTypesChange(e, eachProduct.materialId)} 
                                                checked={eachProduct.processingTypeId === eachProcessingType.id}
                                            />
                                            <label htmlFor={`${eachProduct.materialId} ${eachProcessingType.id}`} className="mr-2" onClick={() => {}} >{eachProcessingType.name}</label>
                                        </div>
                                    )
                                })}
                                {eachProduct.processingTypeId === 3 && 
                                    <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0  p-input-icon-right">
                                        <TextInputField name="newMaterialId" labelText="New MaterialId" placeholder="MaterialId" value={eachProduct.newMaterialId} keyfilter={"pnum"} tooltip={newMaterialTooltipText} tooltipOptions={{position: 'top', showOnDisabled: true, showDelay: 500, hideDelay: 150}} disabled />
                                        <i className="pi pi-search mr-1 mt-1 material-search-icon cursor-pointer" style={{ color: "#00baaa" }} onClick={() => handleNewMaterialClick(eachProduct)} />
                                    </div>
                                }
                            </div>
                        )
                    })
                }
                <div className="flex flex-column col-12 text-area">
                    <TextAreaField name="remarks" labelText="Remarks" rows={3} value={processRejectedStock.remarks} onChange={handleProcessRejectedStockChange} required errorMessage={formErrors.remarks} maxLength={100} />
                </div>
                
            </div>
            <div className='flex justify-content-center align-items-center mt-2'>
                <Button label="Submit" onClick={handleProcessRejectedStockSubmit} />
            </div>
            <Dialog header="Add New Material" className='pi-punch-dialog' visible={isAddNewMaterial} style={{ width: '60vw', height: '70vh', backgroundColor: '#f8f8f8' }} onHide={() => setIsAddNewMaterial(false)}>
                <MaterialSearch selectedMaterialItemIds={[]} handleSelectedMaterialItem={handleAddMaterialItemClick} />
            </Dialog>
        </>
    )
}

export default ProcessRejectedStock